import { lazy } from 'react'

import { FacilityDetailsProvider } from 'contexts/FacilityDetailsContext'
import { Route } from 'react-router-dom'
import { FacilityConfigProvider } from 'contexts/FacilityConfigContext'
import { PermissionProvider } from 'contexts/PermissionContext'
import { AVP_SERVICE_ASSURANCE_SCORECARD } from 'constants/avp_permissions'

const AssetKPIDashboard = lazy(() => import('pages/AssuranceScorecard/AssetKPIDashboard'))
const AssetKPISetup = lazy(() => import('pages/AssuranceScorecard/AssetKPISetup'))
const LoadsheetAssetKPISetup = lazy(() => import('pages/AssuranceScorecard/LoadsheetKPISetup'))
const LoadsheetAssessment = lazy(() => import('pages/AssuranceScorecard/LoadsheetAssessment'))
const PageFormKPIMetric = lazy(() => import('pages/AssuranceScorecard/MetricMeasurementForm'))
const KPIDashboard = lazy(() => import('pages/AssuranceScorecard/KPIDashboard'))
const KPIGroupSetup = lazy(() => import('pages/AssuranceScorecard/KPIGroupSetup'))

const AssuranceScorecardRoutes = (
  <>
    <Route
      path="/assurance-scorecard/project/:project_id"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_ASSURANCE_SCORECARD}>
          <FacilityDetailsProvider>
            <FacilityConfigProvider slug="project_feature_config">
              <KPIDashboard />
            </FacilityConfigProvider>
          </FacilityDetailsProvider>
        </PermissionProvider>
      }
    />
    <Route
      path="/assurance-scorecard/project/:project_id/kpi-setup"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_ASSURANCE_SCORECARD}>
          <FacilityDetailsProvider>
            <FacilityConfigProvider slug="project_feature_config">
              <KPIGroupSetup />
            </FacilityConfigProvider>
          </FacilityDetailsProvider>
        </PermissionProvider>
      }
    />
    <Route
      path="/assurance-scorecard/project/:project_id/asset/:asset_id"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_ASSURANCE_SCORECARD}>
          <FacilityDetailsProvider>
            <FacilityConfigProvider slug="project_feature_config">
              <AssetKPIDashboard />
            </FacilityConfigProvider>
          </FacilityDetailsProvider>
        </PermissionProvider>
      }
    />

    <Route
      path="/assurance-scorecard/project/:project_id/asset/:asset_id/setup"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_ASSURANCE_SCORECARD}>
          <FacilityDetailsProvider>
            <FacilityConfigProvider slug="project_feature_config">
              <AssetKPISetup />
            </FacilityConfigProvider>
          </FacilityDetailsProvider>
        </PermissionProvider>
      }
    />

    <Route
      path="/assurance-scorecard/project/:project_id/asset/:asset_id/setup-loadsheet"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_ASSURANCE_SCORECARD}>
          <FacilityDetailsProvider>
            <FacilityConfigProvider slug="project_feature_config">
              <LoadsheetAssetKPISetup />
            </FacilityConfigProvider>
          </FacilityDetailsProvider>
        </PermissionProvider>
      }
    />

    <Route
      path="/assurance-scorecard/project/:project_id/asset/:asset_id/assessment-loadsheet"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_ASSURANCE_SCORECARD}>
          <FacilityDetailsProvider>
            <FacilityConfigProvider slug="project_feature_config">
              <LoadsheetAssessment />
            </FacilityConfigProvider>
          </FacilityDetailsProvider>
        </PermissionProvider>
      }
    />

    <Route
      path="assurance-scorecard/project/:project_id/asset/:asset_id/metric-form/:metric_id/"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_ASSURANCE_SCORECARD}>
          <FacilityDetailsProvider>
            <FacilityConfigProvider slug="project_feature_config">
              <PageFormKPIMetric />
            </FacilityConfigProvider>
          </FacilityDetailsProvider>
        </PermissionProvider>
      }
    />
  </>
)

export default AssuranceScorecardRoutes
